import { render } from "./SceneWebgl.vue?vue&type=template&id=3857deac"
import script from "./SceneWebgl.vue?vue&type=script&lang=js"
export * from "./SceneWebgl.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__